export default __webpack_public_path__ + "static/media/bindingsoftheskylord.9a9cf0d4.png";